function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import * as R from 'unitx/ramda';
import wrapComponent from "../core/wrapComponent";
import { View } from "./native";
import Accordion from "./Collapsible/Accordion";

function AccordionElement(props, ref) {
  const {
    renderHeader,
    renderSectionTitle,
    activeSections = [],
    sections = []
  } = props,
        rest = _objectWithoutProperties(props, ["renderHeader", "renderSectionTitle", "activeSections", "sections"]);

  const renderHeaderCallback = React.useCallback(R.when(R.isNotNil, () => (...args) => /*#__PURE__*/React.createElement(View, null, renderHeader(...args)))(renderHeader), [renderHeader]);
  const renderSectionTitleCallback = React.useCallback(R.when(R.isNotNil, () => (...args) => /*#__PURE__*/React.createElement(View, null, renderSectionTitle(...args)))(renderSectionTitle), [renderSectionTitle]);
  return /*#__PURE__*/React.createElement(Accordion, _extends({
    ref: ref,
    renderHeader: renderHeaderCallback,
    renderSectionTitle: renderSectionTitleCallback,
    sections: sections,
    activeSections: activeSections
  }, rest));
}

export default wrapComponent(AccordionElement, {
  isForwardRef: true
});